import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { RUN_TYPES } from '~/features/content/utils/content-jobs';

const ContentRunsMapPage = lazy(() => import('~/features/content/pages/content-runs-map-page'));

// The Runs type filter it was opened with, so "← Runs" lands back on the same list.
const searchSchema = z.object({
  from: z.enum(RUN_TYPES).optional().catch(undefined),
});

/** "How runs work" at `/content/runs/how-it-works` (a static segment, so it wins over `$runId`) — the two flows' map, linked from Runs. */
export const Route = createFileRoute('/_authenticated/_tenant/content/runs/how-it-works')({
  // The Content layout already checks the screen permission.
  validateSearch: searchSchema,
  component: RunsMapRoute,
});

function RunsMapRoute() {
  const { from } = Route.useSearch();
  return (
    <Suspense fallback={<PageSkeleton />}>
      <ContentRunsMapPage from={from} />
    </Suspense>
  );
}
